let cliveParam = '';
let paginVar = {pages: 1, loadMore: false, edgePages: false};
const clives = [{
  value: '',
  label: 'All'
}, {
  value: 'wood-newsroom',
  label: 'News'
}, {
  value: 'wood-web-events',
  label: 'Events'
}, {
  value: 'wood-web-investors',
  label: 'Investors'
}];

function encodeQuery(query) {
  return query.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
  // return query.replace(/<\/?[\w\s="\/.':;#-\/\?]+>/gi, "");
}

const changeAccordionsState = (item) => {
  if ($(item).hasClass("active")) {
    $(item).removeClass("active");
  } else {
    $(item).addClass("active");
  }

  $(item)
      .next()
      .slideToggle("fast");
  if ($(window).width() < 768) {
    $(".checkbox-facet > div")
        .not($(item))
        .removeClass("active");

    $(".checkbox-facet > ul")
        .not($(item).next())
        .slideUp("fast");
  }
}

/**
 * @description - Toggles the accordions
 */
const facetAccordions = () => {
  if ($(window).width() < 768) {
  } else {
    $('.facets .checkbox-facet  ul  li  input:checked').parents('.checkbox-facet').find('.checkbox-label').addClass("active").next().show();
  }
  $(".facets .checkbox-facet > div")
      .click(function () {
        changeAccordionsState(this);
      }).keyup(function (e) {
    if (e.keyCode === 13) {
      changeAccordionsState(this);
    }
  });
};

const responsiveFacetsWrapperAccordion = () => {

  $('.facets__wrapper > h2')
      .click(function () {
        if ($('.facets__wrapper').hasClass('accordion')) {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
          } else {
            $(this).addClass("active");
          }

          $(this)
              .next()
              .slideToggle("fast");
        }
      });
}

const accessibleSearch = () => {
  const elements = $('.checkbox-facet label, .active-facets span, .pagination li');
  elements.each(function () {
    $(this).keyup(function (e) {
      if (e.keyCode === 13) {
        $(this).click();
      }
    })
  });
}

/**
 * @description - Hides filters wrapper if there's no filters
 */
const handleFacetsSectionAppearance = () => {
  const section = $('.facets__wrapper');
  const hasFacets = $('.facets__wrapper .facets > div').length > 0;
  if (!hasFacets) {
    section.addClass('hidden');
  } else {
    section.removeClass('hidden');
  }
}

/**
 * @description - Finds clive in given URL and returns it's value
 */
const findClive = () => {
  let url = window.location.search.slice(1).split('&');

  url = url.filter(item => {
    const newItem = item.split('=');
    if (newItem[0] === 'clive') return true;
    return false;
  });

  if (url.length > 0) {
    return url[0].split('=')[1];
  }
  return '';
}

$(document).ready(() => {
  // handleResponsiveChanges();

  if ($(window).width() < 768) {
    if (!$('.facets__wrapper').hasClass('accordion')) {
      $('.facets__wrapper').addClass('accordion');
      responsiveFacetsWrapperAccordion();
    }
  } else {
    $('.facets__wrapper').removeClass('accordion');
    $('.facets').attr('style', '');
  }

  $('a.clive-btn').on('click', function () {
    let searchQueryClive = $('#search-queryinput').val();
    let searchHrefClive = $(this).attr('href');
    let newHrefClive;
    $(this).attr('href', null);
    if (searchHrefClive == '?clive=') {
      newHrefClive = '?query=' + searchQueryClive;
    } else {
      newHrefClive = searchHrefClive + '&query=' + searchQueryClive;
    }
    $(this).attr('href', newHrefClive);
  })

})

$(window).resize(() => {
  // handleResponsiveChanges();

  if ($(window).width() < 768) {
    if (!$('.facets__wrapper').hasClass('accordion')) {
      $('.facets__wrapper').addClass('accordion');
      responsiveFacetsWrapperAccordion();
    }
  } else {
    $('.facets__wrapper').removeClass('accordion');
    $('.facets').attr('style', '');

  }
})

const sharedConfig = {
  url: "https://wood-search01.squiz.co.uk/s/search.json",
  results: {
    numRanks: 10,
  },
  pagination: paginVar,
  onFiltersUpdate: () => {
    facetAccordions();
    handleFacetsSectionAppearance();
    accessibleSearch();
  },
  templates: {
    informationTemplate: (fields, resultsSummary, h) => {
      return `<p>Showing ${resultsSummary.currStart}-${
          resultsSummary.currEnd
          } of ${resultsSummary.totalMatching}</p>`;
    },
    arrowNextTemplate: startrank => {
      return (startrank) ? `<li class="next-page navigation-buttons" tabindex="0" data-startrank=${startrank}></li>` : null;
    },
    arrowPrevTemplate: startrank => {
      return (startrank) ? `<li class="prev-page navigation-buttons" tabindex="0" data-startrank=${startrank}></li>` : null;
    },
    facetCheckbox: ({name, categories, singleChoice, label}, activeFacets, h) => {
      const header = label ? `<div tabindex="0" class="checkbox-label">${label}</div>` : `<div tabindex="0" class="checkbox-label">${name}</div>`;
      let list = "";

      categories[0].values.forEach(item => {
        list += `<li>
                        <input
                        type="checkbox"
                        ${item.checked}
                        value="${item.data}"
                        name="${item.label}"
                        id="${name}-${item.label}"
                        data-fparam="${h.queryStringParamName}"
                        data-singlechoice="${singleChoice}"
                        />
                        <label for="${name}-${item.label}" tabindex="0">${item.label}</label>
                    </li>`;
      });

      return `
                <div class="checkbox-facet" id="${name}">
                    ${header}
                    <ul>
                        ${list}
                    </ul>
                </div>`;
    },
    activeFacet: (name, param) => {
      return `
              <span param="${param}" name="${name}" tabindex="0">
                ${name}
              </span>
            `;
    },
  }
}

if ($("#content-search").length > 0) {
  const mySearch = new Search.default({
    url: sharedConfig.url, // url for funnelback
    collections: [collection], // collection name
    query: {
      value: queryValue,
      canBeChanged: true
    },
    updateUrlOnSearch: false,
    additionalFBparams: additional,
    activeFacetsOnStart: startingFacets,
    results: sharedConfig.results,
    pagination: paginVar,
    facets: {
      items: facetlist
    },
    onFiltersUpdate: sharedConfig.onFiltersUpdate,
    templates: {
      noResults: (query, spell) => {
        let spellSuggestion = '';
        if (spell.text) {
          spellSuggestion = `<div>Did you mean: <a href="?${spell.url}">${spell.text}</a>?</div>`;
          return `<div>We're sorry, we couldn't find anything matching.</div>${spellSuggestion}`;
        }
        return `<div>We're sorry, we couldn't find anything matching.</div>${encodeQuery(query)}`;
      },
      articleTemplate: (fields, highlightFields) => {
        const img = fields.metaData.Previewimage ? `<div class="sidenewsimgwrapper"><img src="${fields.metaData.Previewimage}" class="to-wrap"/></div>` : "";
        if (fields.metaData.Description) {
          return `
                    <div class="results__item">
                    <a href="${fields.clickTrackingUrl}">
                        ${img}
                        <h2>${highlightFields.title}</h2>
                        <p>${fields.metaData.Description}</p>
                    </a>
                    </div>
                `;
        } else {
          return `
                    <div class="results__item">
                    <a href="${fields.clickTrackingUrl}">
                        ${img}
                        <h2>${highlightFields.title}</h2>
                        <p>${fields.summary}</p>
                    </a>
                    </div>
                `;
        }
      },
      informationTemplate: sharedConfig.templates.informationTemplate,
      arrowNextTemplate: sharedConfig.templates.arrowNextTemplate,
      arrowPrevTemplate: sharedConfig.templates.arrowPrevTemplate,
      facetCheckbox: sharedConfig.templates.facetCheckbox,
      activeFacet: sharedConfig.templates.activeFacet
    }
  });

  mySearch.init(); // you need to initialize the fbjs search at the end
} else if ($("#global-search").length > 0) {
  cliveParam = findClive();
  const mySearchGlobal = new Search.default({
    url: sharedConfig.url, // url for funnelback
    collections: [collection], // collection name
    additionalFBparams: {
      // all the parameters that should be added at start ( key is the name, value is the value )
      profile: "_default",
      clive: cliveParam
    },
    results: sharedConfig.results,
    updateUrlOnSearch: false,
    pagination: paginVar,
    facets: {
      items: facetlist
    },
    onFiltersUpdate: sharedConfig.onFiltersUpdate,
    templates: {
      formTemplate: (search, query, inputId) => {
        let clivesButtons = '';

        clives.forEach(item => {
          let classes = item.value === cliveParam ? 'clive-btn active' : 'clive-btn';

          clivesButtons += `<a class="${classes}" data-clive="${item.value}" href="?clive=${item.value}">${item.label}</a>`;
        });

        return `
                    <div class="fbjs-search-content">
                        <form id="search-form">
                        <div class="row">
                            <div class="col-xs-12">
                                <label for="${inputId}">Search for: </label><input id="${inputId}" type="text" value="${encodeQuery(query)}" name="searchquery" placeholder="Type your query"/>
                                <button type="submit" value="" />
                            </div>
                            <div class="col-xs-12">
                                <div id="clives" style="margin-top:25px;">
                                    ${clivesButtons}
                                </div>
                            </div>
                        </div>
                        </form>
                    </div>
                `;
      },
      noResults: (query, spell) => {
        let spellSuggestion = '';
        if (spell.text) {
          spellSuggestion = `<div>Did you mean: <a href="?${spell.url}">${spell.text}</a>?</div>`;
          return `<div>We're sorry, we couldn't find anything matching.</div>${spellSuggestion}`;
        }
        return `<div>We're sorry, we couldn't find anything matching.</div>${encodeQuery(query)}`;
      },
      articleTemplate: (fields, highlightFields) => {
        let breadcrumb;
        if (fields.metaData.Pagelineage) {
          breadcrumb = `<cite><small>${fields.metaData.Pagelineage}</small></cite>`;
        } else if (fields.metaData.Datepublished) {
          breadcrumb = `<cite><small>${fields.metaData.Datepublished.substr(0, 16)}</small></cite>`;
        } else {
          breadcrumb = ' ';
        }
        const content = fields.metaData.Description ? `<p>${fields.metaData.Description}</p>` : `<p>${fields.summary}</p>`;
        const externalTarget = fields.collection == 'wood-newsroom' ? `target="_blank"` : ` `;
        return `
                    <div class="results__item">
                    <a href="${fields.clickTrackingUrl}" ${externalTarget}>
                        <h2>${highlightFields.title}</h2>
                        ${content}
                        ${breadcrumb}
                    </a>
                    </div>
                `;

      },
      bestBets: (bestBets) => {
        let body = '';
        bestBets.forEach((item) => {
          body += `<div class="best-bets__item">
                <a href="${item.linkUrl}">
                    <h2>${item.titleHtml}</h2>
                    <p>${item.descriptionHtml}</p>
                </a>
              </div>`;
        });

        return body;
      },
      informationTemplate: sharedConfig.templates.informationTemplate,
      arrowNextTemplate: sharedConfig.templates.arrowNextTemplate,
      arrowPrevTemplate: sharedConfig.templates.arrowPrevTemplate,
      facetCheckbox: sharedConfig.templates.facetCheckbox,
      activeFacet: sharedConfig.templates.activeFacet
    }
  });

  mySearchGlobal.init(); // you need to initialize the fbjs search at the end
} else if ($("#content-listing-search").length > 0) {
  const mySearchListing = new Search.default({
    url: sharedConfig.url, // url for funnelback
    collections: [collection], // collection name
    query: {
      value: queryValue,
      canBeChanged: true
    },
    additionalFBparams: additional,
    results: {
      numRanks: returnElement,
      target: '.content-listing__list',
    },
    updateUrlOnSearch: false,
    templates: {
      articleTemplate: (fields) => {
        const content = fields.metaData.Description ? `<p>${fields.metaData.Description}</p>` : `<p>${fields.summary.split(/\./).slice(0, 1)}.</p>`;
        const img = fields.metaData.Previewimage ? `<div class="content-listing__image object-fit-fallback"><img src="${fields.metaData.Previewimage}" /></div>` : "";
        return `    
                    <div class="content-listing__item">
                    <a href="${fields.clickTrackingUrl}">
                        ${img}
                        <h3 class="headline__underlined headline__underlined--blue">${fields.title}</h3>
                        ${content}
                        <span>Read more...</span>
                    </a>
                    </div>
                `;
      }
    }
  });

  mySearchListing.init();

}

